export default "__VITE_ASSET__DPR$d1ac__"